/**
 * @file AssesmentInPsychologyListView.jsx
 * @author Fernando Ruano
 * @description Assesment In Psychology List View Page
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import moment from 'moment';

// Helpers
import { sortString } from 'commons/helpers/utils';
import {
  getDefaultColumns,
  PAGE_LIMIT,
  setBadgeVariation
} from '../helper/utils';
import DashboardDetailList from '../dashboardDetailList';

function AssesmentInPsychologyListView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const [rowData, setRowData] = React.useState([]);
  const { classification, totalItems } = useParams();

  const { getAssessmentInPsychologyList } = dashboardStaffActions;

  const columns = [...getDefaultColumns(translate)];

  const additionalColumns = [
    {
      title: translate('Fecha de última valoración'),
      dataIndex: 'fecha_ultima_valoracion',
      sorter: sortString('fecha_ultima_valoracion'),
      ellipsis: true
    },
    {
      title: translate('Riesgo psicosocial'),
      dataIndex: 'riesgo_psicosocial',
      sorter: sortString('riesgo_psicosocial'),
      ellipsis: true
    },
    {
      title: translate('Fecha de registro de riesgo'),
      dataIndex: 'fecha_registro_riesgo',
      sorter: sortString('fecha_registro_riesgo'),
      ellipsis: true
    }
  ];

  const getetData = (offset, pageLimit) => {
    const pageSize = pageLimit || PAGE_LIMIT;
    const data = {
      classification,
      clinicId,
      limit: pageSize,
      offset
    };
    getAssessmentInPsychologyList(data, (_, resp) => {
      if (resp?.data) {
        const adapter = resp.data.map((item) => {
          return {
            ...item,
            fecha_ultima_valoracion: item?.fecha_ultima_valoracion
              ? moment.utc(item.fecha_ultima_valoracion).format('DD-MM-YYYY')
              : '',
            fecha_registro_riesgo: item?.fecha_registro_riesgo
              ? moment.utc(item.fecha_registro_riesgo).format('DD-MM-YYYY')
              : ''
          };
        });
        setRowData(setBadgeVariation(adapter));
      }
    });
  };

  React.useEffect(() => {
    if (clinicId !== null) getetData(1);
  }, [clinicId]);

  return (
    <DashboardDetailList
      columns={columns}
      rowData={rowData}
      totalItems={totalItems}
      additionalColumns={additionalColumns}
      onPaginationChange={getetData}
    />
  );
}

/**
 * Component definition of proptypes.
 */
AssesmentInPsychologyListView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getAssessmentInPsychologyList: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default AssesmentInPsychologyListView;
